import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "./global/GlobalVars.js";
import { renderElement } from "./utils/render.js";

const Content = observer((props) => {
  //========================================================================
  // Status für Seitengröße und Skalierung
  const [pageSize, setPageSize] = useState({ width: "100%", height: "0px" });
  const [scaleFactor, setScaleFactor] = useState(1);

  const HEADER_HEIGHT = 70;

  // Original-Entwurfsauflösung
  const ORIGINAL_WIDTH = 1920;
  const ORIGINAL_HEIGHT = 1010;
  const RATIO = ORIGINAL_WIDTH / ORIGINAL_HEIGHT; // ≈ 0.90099

  //========================================================================
  // Seitengröße und Skalierung anpassen
  useEffect(() => {
    const handleResize = () => {
      const availableHeight = window.innerHeight - HEADER_HEIGHT;
      const availableWidth = window.innerWidth;

      let pageWidth = availableHeight * RATIO;
      let pageHeight = availableHeight;

      if (pageWidth > availableWidth) {
        pageWidth = availableWidth;
        pageHeight = pageWidth / RATIO;
      }

      const newScaleFactor = pageWidth / ORIGINAL_WIDTH;
      setPageSize({ width: `${pageWidth}px`, height: `${pageHeight}px` });
      setScaleFactor(newScaleFactor);
      globalVars.setScaleFactor(newScaleFactor);
      globalVars.setPageSize({
        width: `${pageWidth}px`,
        height: `${pageHeight}px`,
      });
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    // ########################################################################################################
    // ################################################ Content ###############################################
    // ########################################################################################################
    <div
      className="content"
      style={{
        ...pageSize,
        position: "absolute",
        overflow: "hidden",
        left: (window.innerWidth - parseFloat(pageSize.width)) / 2,
      }}
    >
      {globalVars.pageProperties.currentPageConfig.elements?.map(
        (elementToRender, index) => (
          <div key={`${elementToRender.name}-${index}`}>
            {renderElement(elementToRender, scaleFactor, index)}
          </div>
        ),
      )}
    </div>
  );
});

export default Content;
